import "./works.scss";
import React, { useState } from "react";

export default function Works({darkMode}) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const data = [
    {
      id: "1",
      icon: "./assets/mobile.png",
      title: "Summary",
      Multidesc: [
        "Studying Software Engineer specifically MERN Full Stack Developer.",
        " I've worked on many projects with React, Node.js, Express.js, PHP, MySQL.",
        " I have knowledge also about C++, Python, and Flutter.",
        "I am also interested in Data Science and ML.",
        "I am a Software Engineer with experience in both front-end and back-end development.",
        "I have a basic knowledge of Native IOS development and Flutter Framework.",
        
      ],
      img: "https://99designs-blog.imgix.net/blog/wp-content/uploads/2018/10/attachment_100040756-e1538485934255.jpeg?auto=format&q=60&fit=max&w=930",
    },
    {
      id: "2",
      icon: "./assets/globe.png",
      title: "Skills",
      desc: "HTML (5) | CSS (3) | JavaScript (ES6) | Bootstrap | jQuery | ReactJS | Redux | Sass Node.js | Express.js | MongoDB | PHP | MySQL | C++ | C# | Dart | Flutter | Firebase | Data Structure | Algorithms | ASP.NET Core | Python",
      img: "https://i.pinimg.com/originals/e9/c9/2f/e9c92f7869d682a6fa5a97fb8a298f30.jpg",
    },
    {
      id: "3",
      icon: "./assets/writing.png",
      title: "Education",
      Multidesc : ["Computer and Systems Department Faculty of Engineering, Ain Shams University" ,"09.2017 – 06.2022 | Cairo, Egypt"],
      img: "https://i.pinimg.com/originals/a9/f6/94/a9f69465d972a004ad581f245d6ad581.jpg",
    },
  ];

  const handleClick = (way) => {
    way === "left"
      ? setCurrentSlide(currentSlide === 0 ? data.length - 1 : currentSlide - 1)
      : setCurrentSlide(
          currentSlide === data.length - 1 ? 0 : currentSlide + 1
        );
  };

  return (
    <div className={`about ${darkMode? 'light': 'dark'}`} id="about">
      <div
        className="slider"
        // style={{ transform: `translateX(-${currentSlide * 100}vw)` }}
      >
        {data.map((d, key) => {
          console.log("key", key);
          console.log("currentSlide", currentSlide);

          return <div className={`container ${ key === currentSlide  ? 'show-work':"hide-work"} `}>
            <div className="item">
              <div className="left">
                <div className="leftContainer">
                  {/* <div className='imageContainer'>
                                <img src={d.icon} alt='' />
                                </div> */}
                  <h2>{d.title}</h2>
                  {d.Multidesc &&
                    d.Multidesc.map((e) => {
                      return <p>{e}</p>;
                    })}
                  {d.desc && <p>{d.desc}</p>}

                  {/* <span>Projects</span> */}
                </div>
              </div>
              <div className="right">
                <img
                  src="https://99designs-blog.imgix.net/blog/wp-content/uploads/2018/10/attachment_100040756-e1538485934255.jpeg?auto=format&q=60&fit=max&w=930"
                  alt=""
                />
              </div>
            </div>
          </div>
        })}
      </div>

      <img
        src="assets/arrow.png"
        alt=""
        className="arrow left"
        onClick={() => handleClick("left")}
      />
      <img
        src="assets/arrow.png"
        alt=""
        className="arrow right"
        onClick={() => handleClick()}
      />

      <a href="#contact">
        <img src="assets/down.png" alt="" />
      </a>
      <a href="#portfolio" className="arrowUp">
        <img src="assets/down.png" alt="" />
      </a>
    </div>
  );
}
